// { nodeId: [{ studentId, studentName }] } built from a roster snapshot
// (the joinAsTeacher ack). Students still on the start page carry no pin.
const buildPositions = (students) => {
    const positions = {};
    for (const student of students) {
        if (student.situationId && !student.startStatus) {
            positions[student.situationId] = [
                ...(positions[student.situationId] || []),
                { studentId: student.userId, studentName: student.userName },
            ];
        }
    }
    return positions;
};

export default buildPositions;
